var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuantoriLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103.9 29",
    style: {
      enableBackground: "new 0 0 103.9 29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#E6302F;}\n\t.st2{fill:#F7D000;}\n\t.st3{fill:#008EB5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.4,15c0-1.2-0.4-2.3-1.3-3.1c-0.8-0.8-1.9-1.3-3.2-1.3c-1.3,0-2.4,0.4-3.2,1.3c-0.9,0.8-1.3,1.9-1.3,3.1 c0,1.2,0.4,2.3,1.3,3.1c0.8,0.8,1.9,1.3,3.2,1.3c0.9,0,1.8-0.2,2.5-0.7l0.9,0.8l1.2-1.3l-0.9-0.7C42.2,16.7,42.4,15.9,42.4,15z  M40.3,16.2L38.9,15l-1.2,1.3l1.4,1.2c-0.3,0.2-0.7,0.2-1.1,0.2c-0.7,0-1.3-0.3-1.8-0.8c-0.5-0.5-0.7-1.1-0.7-1.9 c0-0.7,0.2-1.4,0.7-1.9c0.5-0.5,1.1-0.8,1.8-0.8c0.7,0,1.3,0.3,1.8,0.8c0.5,0.5,0.7,1.1,0.7,1.9C40.5,15.5,40.4,15.9,40.3,16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.5,15.6c0,0.7-0.2,1.2-0.5,1.5c-0.3,0.3-0.8,0.5-1.3,0.5c-0.6,0-1-0.2-1.3-0.5c-0.3-0.4-0.5-0.9-0.5-1.5 v-4.8H44v4.8c0,1.2,0.3,2.1,1,2.8c0.6,0.6,1.5,1,2.7,1c1.2,0,2.1-0.3,2.7-1c0.7-0.6,1-1.6,1-2.8v-4.8h-1.9V15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.1,10.8l-3.6,8.5h1.9l0.8-1.9h3.6l0.8,1.9h1.9l-3.6-8.5H56.1z M55.8,15.7l1.1-2.7l1.1,2.7H55.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "68.5,16 64.5,10.8 62.8,10.8 62.8,19.2 64.6,19.2 64.6,13.9 68.7,19.2 70.3,19.2 70.3,10.8  68.5,10.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "71.8,12.5 74.4,12.5 74.4,19.2 76.2,19.2 76.2,12.5 78.8,12.5 78.8,10.8 71.8,10.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.1,10.7c-1.3,0-2.4,0.4-3.2,1.3c-0.9,0.8-1.3,1.9-1.3,3.1c0,1.2,0.4,2.3,1.3,3.1c0.8,0.8,1.9,1.3,3.2,1.3 c1.3,0,2.4-0.4,3.2-1.3c0.9-0.8,1.3-1.9,1.3-3.1c0-1.2-0.4-2.3-1.3-3.1C86.4,11.1,85.4,10.7,84.1,10.7z M85.9,16.9 c-0.5,0.5-1.1,0.8-1.8,0.8c-0.7,0-1.3-0.3-1.8-0.8c-0.5-0.5-0.7-1.1-0.7-1.9c0-0.7,0.2-1.4,0.7-1.9c0.5-0.5,1.1-0.8,1.8-0.8 s1.3,0.3,1.8,0.8s0.7,1.1,0.7,1.9C86.6,15.8,86.4,16.4,85.9,16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.3,13.6c0-0.8-0.2-1.5-0.7-1.9c-0.6-0.6-1.4-0.9-2.5-0.9h-3.9v8.4h1.9v-2.7h1.4l1.8,2.7h2.2l-2.1-3 C96.7,15.8,97.3,14.9,97.3,13.6z M95,14.6c-0.2,0.2-0.6,0.3-1,0.3h-1.9v-2.4H94c0.5,0,0.8,0.1,1.1,0.3c0.3,0.2,0.4,0.5,0.4,0.9 C95.4,14.1,95.3,14.4,95,14.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.2,
    y: 10.8,
    className: "st0",
    width: 1.9,
    height: 8.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.4,15.3c0,1.9,1.6,3.5,3.5,3.5c1.9,0,3.5-1.6,3.5-3.5c0-1.9-1.6-3.5-3.5-3.5S12.4,13.4,12.4,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.9,7.8L21.9,7.8C21.6,8.2,21.6,8.7,22,9c2.2,2.1,3.3,5.4,2.4,8.6c0,0.1,0,0.1-0.1,0.2 c-0.1,0.4,0.1,0.9,0.5,1.1c0.5,0.2,1-0.1,1.2-0.6c0-0.1,0-0.1,0.1-0.2c1-3.9-0.2-7.8-2.9-10.4C22.8,7.4,22.2,7.4,21.9,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.8,6.8c0.4-0.1,0.7-0.5,0.7-1l0,0c-0.1-0.5-0.6-0.8-1.1-0.7C9.8,6,6.7,8.8,5.7,12.6c0,0.1,0,0.2-0.1,0.2 c-0.1,0.5,0.2,1,0.7,1.1c0.4,0.1,0.9-0.2,1-0.7c0-0.1,0-0.1,0.1-0.2C8.3,9.9,10.8,7.5,13.8,6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.4,24.3c-0.2-0.4-0.6-0.6-1.1-0.5c-1.5,0.4-3.1,0.5-4.7,0.1c-1.6-0.4-3-1.3-4.1-2.4 c-0.3-0.3-0.8-0.4-1.2-0.1l0,0c-0.4,0.3-0.5,0.9-0.1,1.3c1.3,1.4,3,2.4,4.9,2.9c1.9,0.5,3.9,0.5,5.7-0.1 C19.3,25.3,19.6,24.8,19.4,24.3L19.4,24.3z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 18.4,
    cy: 6,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 22.7,
    cy: 22.2,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 6.6,
    cy: 17.8,
    r: 2.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantoriLogo);
export default __webpack_public_path__ + "static/media/Quantori_logo.7ba7e60550ea708b0bdeae4f156b3235.svg";
export { ForwardRef as ReactComponent };